module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "height": _vm.calcHeight()
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [(!_vm.isEdit) ? [_c('v-card-text')] : _vm._e(), _vm._v(" "), (_vm.isEdit) ? [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Корпоративные заметки",
      "rows": "5",
      "persistent-hint": "",
      "hint": "Корпоративные заметки видны только пользователям Вашей компании"
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "hint": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !this.item.link
    },
    on: {
      "click": _vm.addLink
    }
  }, [_vm._v("Добавить")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-up": "",
      "justify-end": ""
    }
  }, [_c('v-flex', _vm._l((_vm.item.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n          " + _vm._s(tag.name) + "\n          ")])])
  }), 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.addTag
    }
  }, [_vm._v("Метки")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.monitoring),
      expression: "item.monitoring"
    }]
  }, [_vm._v("alarm")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.monitoring),
      expression: "!item.monitoring"
    }]
  }, [_vm._v("alarm_off")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.switchMonitoring
    }
  }, [_vm._v("Мониторинг")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Личные заметки",
      "rows": "2",
      "persistent-hint": "",
      "hint": "Личные заметки видны только Вам"
    },
    model: {
      value: (_vm.item.privateNotes),
      callback: function($$v) {
        _vm.$set(_vm.item, "privateNotes", $$v)
      },
      expression: "item.privateNotes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Банки\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openCompanyBank()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.banks), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createBankTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createBankContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openCompanyBank(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Контакты\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openContact()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.contacts), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openContact(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027ee4dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/NotesForm.vue
// module id = 1021
// module chunks = 1